import { render } from "./HomeTab.vue?vue&type=template&id=0729c34b&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"

import "./HomeTab.vue?vue&type=style&index=0&id=0729c34b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0729c34b"]])

export default __exports__